import { formatToDevanagariStyle } from "@/utilities/helper"

export const columns = [
  { accessorKey: "product_name", header: "Name" },
  { accessorKey: "product_sku", header: "SKU" },
  { accessorKey: "nepal_date", header: "Stock updated" },
  { accessorKey: "current_quantity", header: "Quantity" },
]
